import { IBuilderComponent } from "@faire/web/builder/registerBuilderComponents/types";
import { IFoundationIconProps } from "@faire/web/slate/icons/foundation/FoundationIcon";

export const BuilderConfig: IBuilderComponent<IFoundationIconProps> = {
  name: "FoundationIcon",
  relativePath: "./FoundationIcon.tsx",
  propDefinition: {
    name: "IFoundationIconProps",
    path: "./FoundationIcon.tsx",
  },
  defaultValues: {
    fontSize: 14,
    iconName: "Account",
  },
  canHaveChildren: false,
};
